import '../../../styles/components/tabs.css';

export interface TabOption<T extends string> {
  value: T;
  label: string;
}

interface TabsProps<T extends string> {
  options: TabOption<T>[];
  value: T;
  onChange: (value: T) => void;
  disabled?: boolean;
  className?: string;
  size?: 'sm' | 'md';
}

function Tabs<T extends string>({
  options,
  value,
  onChange,
  disabled = false,
  className = '',
  size = 'md'
}: TabsProps<T>) {
  const classes = [
    'tabs',
    `tabs--${size}`,
    disabled && 'tabs--disabled',
    className
  ].filter(Boolean).join(' ');

  return (
    <div
      className={classes}
      role="tablist"
      aria-disabled={disabled}
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="tab"
          aria-selected={option.value === value}
          className={`tabs__tab ${option.value === value ? 'tabs__tab--active' : ''}`}
          onClick={() => !disabled && onChange(option.value)}
          disabled={disabled}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
